export const legalFormStep5FieldNames = {
  ACCOUNT_PURPOSES: "accountPurposes",
  SELECTED_COUNTRY_FROM: "selectedCountriesFrom",
  SELECTED_COUNTRY_TO: "selectedCountriesTo",
  MONTHLY_TURNOVER: "monthly_turnover",
  CASH_TURNOVER_ID: "cashTurnoverId",
  IS_USA_PERSON: "is_usa_person", // FATCA question
  DIRECTOR_IS_PEP: "directorIsPep",
  ONE_OF_BENEFICIAL_IS_PEP: "oneOfBeneficialIsPep",
  ADDITIONAL_INFORMATION: "additionalInformation",
  ECONOMIC_ACTIVITY: "economicActivity",
  MAIN_ECONOMIC_ACTIVITY: "mainEconomicActivity",
  HAS_USA_TAXES: "has_usa_taxes",
  USA_TAXES_TYPE: "usa_taxes_type",
  USA_TAXES_TYPE_DESC: "usa_taxes_type_desc",
  STREET_INFO: "street_info",
  COUNTRY_INFO: "country_info",
  ACCOUNT_NUMS: "account_nums",
  TIN: "tin",
  PRIVACY_AGREED: "privacy_agreed",
  // kyc
  COMPANY_REGISTRATION_DATE: "companyRegistrationDate",
  COMPANY_JURIDICAL_ADDRESS: "companyJuridicalAddress",
  COUNTRY: "country",
  CITY: "city",
  VILLAGE: "village",
  CITY_VILLAGE: "cityVillage",
  STREET: "street",
  HOME_NUMBER: "homeNumber",
  APARTMENT_NUMBER: "apartmentNumber",
  COMPANY_WEB_PAGE_ADDRESS: "companyWebPageAddress",
  BUSINESS_ACTIVITY_IN_GEORGIA: "businessActivityInGeorgia",
  BUSINESS_ACTIVITY_IN_GEORGIA_NO_DESCRIPTION:
    "businessActivityInGeorgiaNoDescription",
  IS_COMPANY_EXP_IMP: "isCompanyExpImp",
  EXPORT_CONNECTIONS: "exportConnections",
  INFO_COUNTERPARTIES: "infoCounterParties",
  CAPITAL_SOURCES: "capitalSurfaces",
  INCOME_FROM_OTHER_BUSINESS_ACTIVITIES: "incomeFromOtherBusinessActivities",
  OTHER_BUSINESS_ACTIVITIES: "otherBusinessActivities",
  CAPITAL_SOURCES_IN_BANK: "capitalSurfacesInBank",
  CAPITAL_SOURCES_IN_BANK_OTHER: "capitalSurfacesInBankOther",
  WHERE_YOU_HAVE_BANK_ACCOUNTS: "whereYouHaveBankAccounts",
  PLEASE_SPECIFY_BANKS: "pleaseSpecifyBanks",
  MONEY_SOURCES: "moneySources",
  PLEASE_SPECIFY_INCOME_SOURCE: "specify_income_source",
  WEALTH_SOURCES: "wealthSources",
  PLEASE_SPECIFY_WEALTH: "please_specify_wealth",
  CONFIRMATION_STATUS: "ConfirmationStatus",
  CATEGORY_OF_POLITICALLY_EXPOSED: "categoryOfPoliticallyExposed",
  INFORMATION_ABOUT_RELATED_PEP: "informationAboutRelatedPep",
  OWNERS_INFO: "owners_info",
  PAGE: "page",
  CONFIRM_KYC: "confirm_KYC",
};

export const KYC_SCORE = 100;

export const conditionsForKYC = {
  legalForm: "4",
  oneOfBeneficialIsPep: "yes",
  kycScore: KYC_SCORE,
};

export const PAGES = {
  mainFrom: 1,
  KYCFrom: 2,
  beneficialOwner: 3,
  confirmKYC: 4,
};

const trimValue = (value) => value.trim();

export const setInputName = (name, id) => {
  return (
    legalFormStep5FieldNames.OWNERS_INFO + "_" + id + "_" + trimValue(name)
  );
};

export const RELATED_PEP_NO_VAL = "0";

export const PEP_VALUE_IDS = {
  no: 0,
  pep: 1,
  family_member: 2,
  business_owner: 3,
  additional_info: 4,
};
